import { createAction } from 'redux-actions';

import { openFailedAlert } from 'actions/alert';
import { wrapFetchAuth } from 'actions/endpoint';

export const updateSongKeyword = createAction('UPDATE_SONG_KEYWORD', value => ({ value }));
export const addFavoriteSong = createAction('ADD_FAVORITE_SONG', id => ({ id }));
export const removeFavoriteSong = createAction('REMOVE_FAVORITE_SONG', id => ({ id }));

export const getSong = createAction('FETCH_SONG', async keyword => {
	const { status, message, data } = await wrapFetchAuth(
		'user/searchSong',
		{
			method: 'GET',
		},
		{
			q: keyword,
			limit: 50,
			offset: 0,
		},
	);

	if (status !== 200) {
		throw openFailedAlert('generic', message);
	}

	const songData = {};

	const list = data.tracks.items.map(item => {
		songData[item.id] = item;

		return item.id;
	});

	return { list, data: songData, limit: 10, offset: 0 };
});

export const updateSongKeywordEpic = action$ =>
	action$
		.ofType('UPDATE_SONG_KEYWORD')
		.debounceTime(500)
		.filter(action => action.payload.value !== '')
		.switchMap(async action => getSong(action.payload.value));



// WEBPACK FOOTER //
// ./src/actions/song.js